import { render, staticRenderFns } from "./MobileTemplate.vue?vue&type=template&id=89c75e30&scoped=true"
import script from "./MobileTemplate.vue?vue&type=script&lang=js"
export * from "./MobileTemplate.vue?vue&type=script&lang=js"
import style0 from "./MobileTemplate.vue?vue&type=style&index=0&id=89c75e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c75e30",
  null
  
)

export default component.exports